import { useState } from 'react';
import { KeyRound } from 'lucide-react';
import { toast } from 'sonner';
import { apiFetch, erroApi } from './api';
import { useAuth } from './AuthContext';

export default function Configuracoes() {
  const { user } = useAuth();
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [enviando, setEnviando] = useState(false);

  const trocar = async (e) => {
    e.preventDefault();
    if (novaSenha.length < 8) { toast.error('A nova senha precisa ter pelo menos 8 caracteres.'); return; }
    if (novaSenha !== confirmar) { toast.error('A confirmação não confere com a nova senha.'); return; }
    setEnviando(true);
    const r = await apiFetch('/auth/change-password', { method: 'POST', body: JSON.stringify({ senhaAtual, novaSenha }) });
    setEnviando(false);
    if (r.ok) {
      toast.success('Senha alterada com segurança!');
      setSenhaAtual(''); setNovaSenha(''); setConfirmar('');
    } else {
      toast.error(erroApi((await r.json().catch(() => ({}))).detail));
    }
  };

  const inputCls = 'mt-1 w-full rounded-xl border border-slate-300 bg-white px-4 py-2.5 text-sm outline-none focus:border-mk-blue focus:ring-2 focus:ring-mk-blue/20';
  const labelCls = 'text-xs font-bold uppercase tracking-wide text-slate-500';

  return (
    <div data-testid="admin-config" className="max-w-md">
      <h1 className="font-heading text-2xl font-extrabold text-slate-900">Configurações da conta</h1>
      <div className="mt-4 rounded-2xl bg-white p-5 shadow-sm">
        <p className="text-sm text-slate-500">Conta: <span className="font-bold text-slate-800">{user?.email}</span></p>
      </div>
      <form onSubmit={trocar} className="mt-4 space-y-4 rounded-2xl bg-white p-5 shadow-sm">
        <h2 className="flex items-center gap-2 font-heading text-base font-extrabold text-slate-900"><KeyRound size={17} /> Alterar senha</h2>
        <div>
          <label className={labelCls}>Senha atual</label>
          <input data-testid="config-senha-atual" type="password" required value={senhaAtual} onChange={(e) => setSenhaAtual(e.target.value)} className={inputCls} />
        </div>
        <div>
          <label className={labelCls}>Nova senha</label>
          <input data-testid="config-nova-senha" type="password" required minLength={8} value={novaSenha} onChange={(e) => setNovaSenha(e.target.value)} className={inputCls} />
        </div>
        <div>
          <label className={labelCls}>Confirmar nova senha</label>
          <input data-testid="config-confirmar-senha" type="password" required value={confirmar} onChange={(e) => setConfirmar(e.target.value)} className={inputCls} />
        </div>
        <button data-testid="config-save-button" disabled={enviando} className="w-full rounded-full bg-mk-blue py-3 text-sm font-bold text-white hover:bg-mk-bluelight disabled:opacity-60">
          {enviando ? 'Salvando...' : 'Salvar nova senha'}
        </button>
      </form>
    </div>
  );
}
